const wallets = {
  btc: {
    name: "Bitcoin",
    short: "BTC",
  },
  eth: {
    name: "Ethereum",
    short: "ETH",
  },
  bnb: {
    name: "Binance Coin",
    short: "BNB",
  },
  trx: {
    name: "Tron",
    short: "TRX",
  },
  ltc: {
    name: "Litecoin",
    short: "LTC",
  },
  usdt: {
    name: "TetherUS",
    short: "USDT",
  },
  usdc: {
    name: "USD Coin",
    short: "USDC",
  },
  sol: {
    name: "Solana",
    short: "SOL",
  },
  ton: {
    name: "TON",
    short: "TON",
  },
  pyusd: {
    name: "PyUSD",
    short: "PYUSD",
  },
};

export const cryptos = Object.keys(wallets);

export const additionalCryptos = [
  "usdtrx",
  "usdtbsc",
  "usdt20",
  "bnbbsc",
  "usdtsol",
  "usdton",
  "usdcarb",
  "usdcbase",
  "usdcbsc",
  "etharb",
  "ethbase",
  "ethbsc",
];
export const additionalChangellyUsdtCryptos = [
  "usdtrx",
  "usdtbsc",
  "usdt20",
  "usdtsol",
  "usdton",
];

export const additionalChangellyUsdcCryptos = [
  "usdcarb",
  "usdcbase",
  "usdcbsc",
];

export const refactoredCryptoKey = (coin: string) => {
  if (additionalChangellyUsdtCryptos.includes(coin)) {
    return "usdt";
  }

  if (additionalChangellyUsdcCryptos.includes(coin)) {
    return "usdc";
  }

  if (coin === "bnbbsc") {
    return "bnb";
  }

  return coin;
};

export const externalUsdtNetwork = {
  usdt: "trx",
  usdtrx: "trx",
  usdtbsc: "bnb",
  usdt20: "eth",
  bnbbsc: "bnb",
  usdtsol: "sol",
  usdton: "ton",
};

export default wallets;
